<template>
  <div class="footer-join">
    <div class="container">
      <el-row>
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" class="head">
          <h1 class="text-white footer-text">{{footerText.heading}}</h1>
        </el-col>
        <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <p class="content-std text-white footer-text join-sub-text">{{footerText.sub}}</p>
        </el-col>
        <el-button class="join-btn-bottom" type="primary" @click="$router.push({ name: 'Signup Select Type' })">Join the network</el-button>
         <!-- <p class="text-white footer-text">Or call <a class="call-link" href="tel:+441412282990"> +44(0)141 228 2990 </a> (Mon - Fri 8:30am to 5:30pm)</p> -->
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      footerText: {
        heading: "Join the network today",
        sub:
          "The CWB community is free to join. Whether you're looking for support for your business, or have the skills and experience to help businesses or individuals, we look forward to welcoming you."
      }
    };
  }
};
</script>
<style>
.footer-text {
  text-align: center;
  margin-top: 30px;
}
h1 {
  font-weight: 400;
}
.footer-text {
  padding-top: 10px;
  padding-bottom: 10px;
}
.join-btn-bottom {
  margin: auto;
}
.give-feedback p {
  color: white;
  margin-left: 10px;
  /* float: left; */
  text-decoration: underline;
}
.give-feedback {
  text-align: center;
  padding-top: 45px;
}
</style>
